import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Login from './components/Login'
import DiscoveryCallForm from './components/DiscoveryCallForm'
import EditDiscoveryCallForm from './components/EditDiscoveryCallForm'
import ProtectedRoute from './components/ProtectedRoute'
import RootRedirect from './components/RootRedirect'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/form"
              element={
                <ProtectedRoute>
                  <DiscoveryCallForm />
                </ProtectedRoute>
              }
            />
            {/* Edit route for updating existing form */}
            <Route
              path="/form/edit"
              element={
                <ProtectedRoute>
                  <EditDiscoveryCallForm />
                </ProtectedRoute>
              }
            />
            {/* Redirect root based on authentication status */}
            <Route path="/" element={<RootRedirect />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App

